window.Helpers = window.Helpers || {};
window.Helpers.WaitForElement = function (element) {
  return new Promise((resolve) => {
    if (document.querySelector(element)) {
      resolve(document.querySelector(element));
    } else {
      const observer = new MutationObserver((mutations) => {
        if (document.querySelector(element)) {
          observer.disconnect();
          resolve(document.querySelector(element));
        }
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }
  });
};
window.Helpers.WaitFor = function (variable) {
  return new Promise((resolve) => {
    if (window[variable]) {
      resolve(window[variable]);
    } else {
      const interval = setInterval(() => {
        if (window[variable]) {
          clearInterval(interval);
          resolve(window[variable]);
        }
      }, 100);
    }
  });
};
window.Helpers.WaitForCustomElement = function (name) {
  return new Promise((resolve) => {
    if (customElements.get(name)) {
      resolve();
    } else {
      let wait = setInterval(() => {
        if (customElements.get(name)) {
          clearInterval(wait);
          resolve();
        }
      }, 25);
    }
  });
};

class API {
  constructor(token, version) {
    this.token = token;
    this.version = version || '2024-07';
    this.headers = {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': this.token,
    };
    this.gqlRoute = '/api/' + this.version + '/graphql.json';
    let _this = this;

    this.GraphQL = {
      Request: function (query, variables) {
        return _this.Request(_this.gqlRoute, 'POST', _this.headers, JSON.stringify({ query, variables }));
      },
      RequestSync: function (query, variables) {
        return _this.RequestSync(_this.gqlRoute, 'POST', _this.headers, JSON.stringify({ query, variables }));
      },
    };
  }
  Request(url, method, headers, data) {
    return fetch(url, {
      method: method,
      headers: headers,
      body: data,
    });
  }
  RequestSync(url, method, headers, data) {
    const xhr = new XMLHttpRequest();
    xhr.open(method, url, false);
    if (headers && Object.keys(headers) && Object.keys(headers).length) {
      Object.keys(headers).forEach((header) => {
        xhr.setRequestHeader(header, headers[header]);
      });
    }
    xhr.send(data);
    if (xhr.status === 200) {
      return JSON.parse(xhr.responseText);
    } else {
      throw new Error('Request failed: ' + xhr.statusText);
    }
  }
}
window.Helpers.API = new API(window.Helpers.Config.storefront.token, window.Helpers.Config.storefront.version);

class HelpersCustomer {
  constructor(customer_data) {
    this.reg = customer_data ? true : false;
    this.id = customer_data ? customer_data.id : null;
    this.email = customer_data ? customer_data.email : null;
    this.phone = customer_data ? customer_data.phone : null;
    this.name = customer_data ? customer_data.name : null;
    this.tags = customer_data ? customer_data.tags : null;

    this.fp = this.getFp();
  }
  getFp() {
    if (
      window.ShopifyAnalytics &&
      window.ShopifyAnalytics.lib &&
      window.ShopifyAnalytics.lib.user &&
      window.ShopifyAnalytics.lib.user().traits &&
      window.ShopifyAnalytics.lib.user().traits().uniqToken
    ) {
      return ShopifyAnalytics.lib.user().traits().uniqToken;
    } else {
      return false;
    }
  }
  getLocation() {
    const _this = this;
    return new Promise((resolve) => {
      if (_this.location) {
        resolve(_this.location);
      } else if (sessionStorage.getItem('user_location')) {
        const user_location = JSON.parse(sessionStorage.getItem('user_location'));
        _this.location = user_location;
        resolve(user_location);
      } else {
        fetch(window.Helpers.Config.routes.root + 'browsing_context_suggestions.json')
          .then((res) => res.json())
          .then((r) => {
            _this.location = r.detected_values;
            sessionStorage.setItem('user_location', JSON.stringify(r.detected_values));
            resolve(r.detected_values);
          });
      }
    });
  }
}

window.Helpers.Customer = new HelpersCustomer(window.Helpers.Config.customer);

class YotpoAPI {
  constructor() {}
  Action(action_name) {
    if (!action_name) {
      console.warn('Yotpo action requires action name');
      return;
    }
    if (!window.Helpers.Customer.email) {
      console.warn('Yotpo action requires customer email');
      return;
    }

    return fetch(
      'https://allies-api.sintraconsulting.pl/shopify/' + window.Helpers.Config.environment + '/yotpo-actions',
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: window.Helpers.Customer.email, action: action_name }),
      },
    );
  }
}
window.Helpers.API.Yotpo = new YotpoAPI();

window.Helpers.Sections = {
  OnEventUrl: function (event, url) {
    if (!url) url = window.location.href;
    if (window.renderOnEvent[event]) {
      if (url.indexOf('?') > -1) {
        url = url + '&';
      } else {
        url = url + '?';
      }
      url = url + 'sections=';
      url = url + window.renderOnEvent[event].join(',');
    }
    return url;
  },

  OnEventForm: function (event, form) {
    if (event && window.renderOnEvent[event]) {
      window.renderOnEvent[event].forEach((sectionId) => {
        const section =
          document.querySelector('#shopify-section-' + sectionId) ||
          document.querySelector('[data-section-id="' + sectionId + '"]') ||
          document.querySelector('[data-section-id="shopify-section-' + sectionId + '"]') ||
          document.querySelector('#' + sectionId);
        if (section) {
          //console.log('section loading', section);
          section.classList.add('section-loading');
        }
      });
      if (form) {
        const formData = new FormData(form);
        formData.append('sections', window.renderOnEvent[event].join(','));
        return formData;
      }
    }
  },
  OnEventError: function (event) {
    if (event && window.renderOnEvent[event]) {
      window.renderOnEvent[event].forEach((sectionId) => {
        const section =
          document.querySelector('#shopify-section-' + sectionId) ||
          document.querySelector('[data-section-id="' + sectionId + '"]') ||
          document.querySelector('[data-section-id="shopify-section-' + sectionId + '"]') ||
          document.querySelector('#' + sectionId);
        if (section) {
          //console.log('section loading', section);
          section.classList.remove('section-loading');
        }
      });
    }
  },
  OnEventObject: function (event, obj) {
    if (window.renderOnEvent[event]) {
      if (obj instanceof Array) {
      } else if (obj instanceof Object) {
        obj.sections = window.renderOnEvent[event].join(',');
      }
    }
    return obj;
  },
  Render: function (json) {
    if (!json) return;
    Object.keys(json).forEach((key) => {
      const id = 'shopify-section-' + key;
      if (document.querySelector('#' + id)) {
        document.querySelectorAll('#' + id).forEach((el) => {
          el.outerHTML = json[key];
        });
      } else if (document.querySelector('[data-section-id="' + id + '"]')) {
        const tempEl = document.createElement('div');
        tempEl.innerHTML = json[key];
        const updateEl = tempEl.querySelector('[data-section-id="' + id + '"]') || tempEl;
        document.querySelectorAll('[data-section-id="' + id + '"]').forEach((el) => {
          el.outerHTML = updateEl.outerHTML;
        });
        //document.querySelector('[data-section-id="' + id + '"]').outerHTML = json[key];
      }
    });
  },
  Fetch: function (sectionIds, url) {
    if (!url) {
      url = window.Helpers.Config.routes.root;
    }
    if (url.indexOf('?') > -1) {
      url += `&`;
    } else {
      url += `?`;
    }
    url += `sections=${sectionIds.join(',')}`;

    return fetch(url).then((res) => res.json());
  },
};

window.Helpers.UpdateUrl = function (url) {
  window.history.pushState({}, '', url);
};

class APICart {
  constructor(routes) {
    this.headers = {
      'Content-Type': 'application/json',
    };
    this.routes = routes;
  }
  Add(data) {
    return Helpers.API.Request(this.routes.add, 'POST', this.CheckData(data).headers, this.CheckData(data).data);
  }
  AddSync(data) {
    return Helpers.API.RequestSync(this.routes.add, 'POST', this.CheckData(data).headers, this.CheckData(data).data);
  }
  Change(data) {
    return Helpers.API.Request(this.routes.change, 'POST', this.CheckData(data).headers, this.CheckData(data).data);
  }
  ChangeSync(data) {
    return Helpers.API.RequestSync(this.routes.change, 'POST', this.CheckData(data).headers, this.CheckData(data).data);
  }
  Update(data) {
    return Helpers.API.Request(this.routes.update, 'POST', this.CheckData(data).headers, this.CheckData(data).data);
  }
  UpdateSync(data) {
    return Helpers.API.RequestSync(this.routes.update, 'POST', this.CheckData(data).headers, this.CheckData(data).data);
  }
  Clear() {
    return Helpers.API.Request(this.routes.clear, 'POST', this.headers);
  }
  ClearSync() {
    return Helpers.API.RequestSync(this.routes.clear, 'POST', this.headers);
  }
  CheckData(data) {
    //console.log('adddata', data, typeof data);
    if (data instanceof FormData) {
      //console.log('formdata!');
      return {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: new URLSearchParams(data),
      };
    } else if (data instanceof Object) {
      //console.log('object!');
      return {
        headers: this.headers,
        data: JSON.stringify(data),
      };
    } else {
      return {
        headers: this.headers,
        data: data,
      };
    }
  }
}
window.Helpers.API.Cart = new APICart(window.Helpers.Config.routes.cart);

class APIApp {
  constructor(url) {
    this.url = url;
    this.headers = {
      'Content-Type': 'application/json',
    };
  }

  SyncToKlaviyo(properties, email) {
    return fetch(this.GetApiPath('klaviyo-property'), {
      method: 'POST',
      headers: this.headers,
      body: JSON.stringify({ properties: properties, email: email }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        console.log('Klaviyo properties sync', data);

        return data;
      });
  }

  GetApiPath(fileName) {
    //return (this.url + '/' + fileName).replace(/\/\//g, '/');
    return this.GetApiUrl(fileName);
  }

  GetApiUrl(path, params) {
    const fixedPath = path.indexOf('/') == 0 ? path.substring(1) : path;
    const fixedUrl =
      this.url.indexOf('http') == 0
        ? this.url
        : new URL(
            ((this.url.indexOf('/') == 0 ? this.url : '/' + this.url) + '/').replace('//', '/'),
            window.location.href,
          ).href;
    const url = new URL(fixedPath, fixedUrl);

    if (params) {
      Object.keys(params).forEach((key) => url.searchParams.set(key, params[key]));
    }

    return url.href;
  }

  Discount(params) {
    return Helpers.API.Request(this.GetApiUrl('discount', params), 'GET', this.headers);
  }

  StaffContact(subject, message) {
    return fetch(this.GetApiPath('staff-contact'), {
      method: 'POST',
      headers: this.headers,
      body: JSON.stringify({
        subject: subject,
        message: message,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log('StaffContact response', data);
        return data;
      });
  }

  Submissions(data) {
    return fetch(this.GetApiPath('submissions'), {
      method: 'POST',
      headers: this.headers,
      body: JSON.stringify({
        data: data,
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        console.log('Submissions response', res);
        return res;
      });
  }
}
window.Helpers.API.App = new APIApp(window.Helpers.Config.app.url);

window.Helpers.onIdle = function (callback) {
  if ('requestIdleCallback' in window) {
    requestIdleCallback(callback, { timeout: 0 });
  } else {
    requestAnimationFrame(() => callback);
  }
};

class AssetsLoader {
  constructor() {
    this.loaded = [];
    this.reqAttribute = 'data-require';
    this.reqIntersectionObserver = false;
    this.reqClickAttribute = 'data-require-click';
    this.mutationObserver = false;
    this.attachListeners();
  }
  loadStyle(src, callback) {
    const newStyle = document.createElement('link');
    newStyle.rel = 'stylesheet';
    newStyle.href = src;
    if (typeof callback !== 'undefined') {
      newStyle.onload = callback;
    }
    document.head.appendChild(newStyle);
  }
  loadScript(src, where, el, defer, async, callback) {
    if (this.loaded.indexOf(src) > -1) return;
    if (el) {
      if (where == 'this') {
        el.type = 'text/javascript';
        if (typeof callback != 'undefined') {
          el.onload = callback(el);
        }
      } else {
        let newScript = document.createElement('script');
        newScript.src = src;
        if (typeof callback !== 'undefined') {
          newScript.onload = callback(el);
        }
        if (where == 'before') {
          el.parentNode.insertBefore(newScript, el);
        } else {
          document.body.appendChild(newScript);
        }
      }
    } else {
      let newScript = document.createElement('script');
      newScript.src = src;
      if (typeof callback !== 'undefined') {
        newScript.onload = callback;
      }
      if (defer) {
        newScript.defer = true;
      }
      if (async) {
        newScript.async = true;
      }
      document.body.appendChild(newScript);
    }

    this.loaded.push(src);
  }
  loadScriptIdle(src, where, el, callback) {
    if (this.loaded.indexOf(src) > -1) return;
    window.Helpers.onIdle(() => {
      this.loadScript(src, where, el, true, true, callback);
    });
  }
  loadElementDependencies(el) {
    if (!el.querySelector('script[type="javascript/dependant"]')) return;
    window.Helpers.invokeElementDependencies(el);
  }
  invokeElementDependencies() {
    el.querySelectorAll('script[type="javascript/dependant"]').forEach(function (oldScriptTag) {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      newScriptTag.type = 'text/javascript';
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
  loadReq(req, attr) {
    if (!attr) attr = this.reqAttribute;
    const _this = this;
    //console.log('loadReq', req, attr);
    const require = req.getAttribute(attr);
    if (!require) return;
    //console.log('req', req);
    require.split(',').forEach(function (src) {
      _this.loadScript(src.trim().replace('[shop]', Shopify.shop), 'footer', req, 0, 1, _this.loadElementDependencies);
    });
  }

  attachElementClickListeners(el) {
    const _this = this;
    el.addEventListener('click', function (e) {
      let target = e.target.getAttribute(_this.reqClickAttribute)
        ? e.target
        : e.target.closest('[' + _this.reqClickAttribute + ']');
      _this.loadReq(target, _this.reqClickAttribute);
    });
    el.addEventListener(
      'mouseenter',
      function (e) {
        _this.loadReq(e.target, _this.reqClickAttribute);
      },
      { once: true, passive: true },
    );
    el.addEventListener(
      'touchstart',
      function (e) {
        _this.loadReq(e.target, _this.reqClickAttribute);
      },
      { once: true, passive: true },
    );
  }

  attachListeners() {
    const _this = this;
    if (typeof IntersectionObserver == 'function') {
      this.reqIntersectionObserver = new IntersectionObserver(
        function (entries, observer) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              if (entry.target.getAttribute(_this.reqAttribute)) {
                _this.loadReq(entry.target);
              }
              observer.unobserve(entry.target);
            }
          });
        },
        {
          root: document,
          rootMargin: '50% 0px 50% 0px',
        },
      );
    }
    document.querySelectorAll('[' + this.reqAttribute + ']').forEach(function (req) {
      if (_this.reqIntersectionObserver) {
        _this.reqIntersectionObserver.observe(req);
      } else {
        _this.loadReq(req);
      }
    });
    document.querySelectorAll('[' + this.reqClickAttribute + ']').forEach(function (req) {
      _this.attachElementClickListeners(req);
    });

    this.mutationObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.addedNodes) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) {
              if (node.hasAttribute(_this.reqAttribute)) {
                _this.loadReq(node);
              } else if (node.hasAttribute(_this.reqClickAttribute)) {
                _this.attachElementClickListeners(node);
              }
            }
          });
        }
      });
    });
  }
}
window.Helpers.AssetsLoader = new AssetsLoader();

/*
 * Clipboard. Usage: Helpers.Clipboard.Copy('text') or const text = Helpers.Clipboard.Paste()
 */
window.Helpers.Clipboard = {
  Copy: function (text) {
    const el = document.createElement('textarea');
    el.value = text;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    return true;
  },
  Paste: function () {
    const el = document.createElement('textarea');
    document.body.appendChild(el);
    el.select();
    document.execCommand('paste');
    const text = el.value;
    document.body.removeChild(el);
    return text;
  },
};

window.Helpers.Cookie = {
  Get: function (cname) {
    let name = cname + '=';
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return false;
  },
  Set: function (cname, cvalue, exseconds) {
    const d = new Date();
    d.setTime(d.getTime() + exseconds * 1000);
    let expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/;' + 'domain=.' + window.location.host;
  },
  Delete: function (name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.' + window.location.host;
  },
};

class Responsiveness {
  constructor(config) {
    this.breakpoints = config;
    this.breakpointsArr = Object.keys(this.breakpoints);
    this.mobileBreakpoints = this.breakpointsArr.filter(function (e) {
      return config[e] < 750;
    });
    this.mobilePointer = window.matchMedia('(pointer:fine)').matches ? false : true;
    this.currentBreakpoint = '';
    this.windowWidth = window.innerWidth;
    this.windowHeight = window.innerHeight;
    this.rootElement = document.querySelector(':root');
    //this.headerWrap = document.querySelector('#top');
    this.mainAnnouncements = document.querySelector('#announcements');
    this.mainHeader = document.querySelector('#main-header');
    this.headerNav = document.querySelector('#main-header__nav');
    this.setCSSVariables();
    this.setup();
    //this.openCloseDetails();
  }

  setCSSVariables() {
    this.rootElement.style.setProperty('--window-width', this.windowWidth + 'px');
    this.rootElement.style.setProperty('--window-height', this.windowHeight + 'px');
    const mainHeaderHeight = this.mainHeader.clientHeight;
    if (this.mainAnnouncements) {
      this.rootElement.style.setProperty('--announcements-height', this.mainAnnouncements.clientHeight + 'px');
      this.rootElement.style.setProperty(
        '--header-height',
        this.mainAnnouncements.clientHeight + mainHeaderHeight + 'px',
      );
    } else {
      this.rootElement.style.setProperty('--header-height', mainHeaderHeight + 'px');
    }
    this.mainHeaderHeight = mainHeaderHeight;
    this.rootElement.style.setProperty('--main-header-height', mainHeaderHeight + 'px');
    this.headerNavHeightCache = this.headerNav.clientHeight;
    this.rootElement.style.setProperty('--header-nav-height', this.headerNav.clientHeight + 'px');

    const setDynamicHeaderHeight = () => {
      const headerRect = this.mainHeader.getBoundingClientRect();
      const dynamicHeaderHeight = headerRect.height + headerRect.top + 1;
      this.rootElement.style.setProperty('--dynamic-header-height', dynamicHeaderHeight + 'px');
    };
    setDynamicHeaderHeight();

    document.addEventListener('DOMContentLoaded', () => {
      setDynamicHeaderHeight();
    });
    window.addEventListener('scroll', () => {
      setDynamicHeaderHeight();
    });
  }

  /*
  openCloseDetails() {
    const _this = this;
    let details = document.querySelectorAll('details');
    //console.log('_this.currentBreakpoint', _this.currentBreakpoint);
    details.forEach((detail) => {
      //console.log('detail', detail, detail.hasAttribute(_this.currentBreakpoint + '-open'));
      if (detail.hasAttribute(_this.currentBreakpoint + '-open')) {
        //console.log('show by core.js - RWD', detail);
        detail.open = true;
      }
    });
  }
    */

  setup() {
    this.attachListeners();
    let _this = this;
    this.breakpointsArr.forEach(function (breakpointName, i) {
      var minWidth = _this.breakpoints[breakpointName];
      var nextBreakpointName = _this.breakpointsArr[i + 1];
      var maxWidth = nextBreakpointName ? _this.breakpoints[nextBreakpointName] : false;
      var mql = window.matchMedia(`(min-width: ${minWidth}px)${maxWidth ? `and (max-width: ${maxWidth - 1}px)` : ''}`);
      //console.log('mql', mql);
      mql.onchange = (e) => {
        _this.checkUpdatedMql(e, breakpointName);
      };
      _this.checkMql(mql, breakpointName);
    });
  }

  attachListeners() {
    let _this = this;
    window.addEventListener('resize', function () {
      _this.mobilePointer = window.matchMedia('(pointer:fine)').matches ? false : true;

      if (_this.windowWidth != window.innerWidth) {
        _this.windowWidth = window.innerWidth;
        window.dispatchEvent(new CustomEvent('rwd:width-change', { bubbles: false }));
      }
      if (_this.windowHeight != window.innerHeight) {
        _this.windowHeight = window.innerHeight;
        window.dispatchEvent(new CustomEvent('rwd:height-change', { bubbles: false }));
      }
      _this.setCSSVariables();
    });
  }
  checkMql(mql, breakpointName) {
    if (mql.matches) {
      this.currentBreakpoint = breakpointName;
      this.isMobile = this.mobileBreakpoints.includes(breakpointName) || this.mobilePointer;
    }
  }
  checkUpdatedMql(mql, breakpointName) {
    if (mql.matches) {
      //console.log('mql', mql, breakpointName);
      this.currentBreakpoint = breakpointName;
      this.isMobile = this.mobileBreakpoints.includes(breakpointName) || this.mobilePointer;
      //this.openCloseDetails();
      window.dispatchEvent(new CustomEvent('rwd:bp-change', { bubbles: false }));
    }
  }
}

window.Helpers.RWD = new Responsiveness(window.Helpers.Config.breakpoints);

/*
 * Analytics. Usage: Helpers.Analytics.Push('event_name', { key: data, key2: data2 })
 */
window.Helpers.Analytics = {
  Push: function (event, data) {
    try {
      if (!data) data = {};
      if (Shopify.analytics) {
        if (window.Helpers.Customer) {
          if (window.Helpers.Customer.fp) {
            data['fp'] = window.Helpers.Customer.fp;
          }
          if (window.Helpers.Customer.id) {
            data['customer_id'] = window.Helpers.Customer.id;
          }
        }
        Shopify.analytics.publish(event, data);
      } else {
        console.warn('Shopify.analytics not found');
      }
    } catch (e) {
      console.error(e);
    }
  },
};

window.Helpers.Money = function (cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || window.Helpers.Config.money.default_format;

  function formatWithDelimiters(number, precision, thousands, decimal) {
    thousands = thousands || ',';
    decimal = decimal || '.';

    if (isNaN(number) || number === null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.');
    var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

//debounce function
function debounce(func, delay, immediate = false) {
  let timeout;
  return function (...args) {
    const context = this;
    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, delay);
    if (callNow) func.apply(context, args);
  };
}

window.Helpers.debounce = debounce;

class BaseHTMLElement extends HTMLElement {
  constructor() {
    super();

    this.safeEventListeners = [];
    this.safeWindowEventListeners = [];
    this.safeDocumentEventListeners = [];

    if (/complete|interactive|loaded/.test(document.readyState)) {
      setTimeout(this.init.bind(this), 1);
    } else {
      this.onDocumentLoaded(() => this.init());
    }

    this.debugger = makeDebugger();
  }

  // called on document loaded
  init() {}

  // each time element is moved
  connectedCallback() {}

  disconnectedCallback() {
    this.safeEventListeners.forEach((event) => {
      this.removeEventListener(event.type, event.listener, event.options);
    });
    this.safeEventListeners = [];

    this.safeDocumentEventListeners.forEach((event) => {
      document.removeEventListener(event.type, event.listener, event.options);
    });
    this.safeDocumentEventListeners = [];

    this.safeWindowEventListeners.forEach((event) => {
      window.removeEventListener(event.type, event.listener, event.options);
    });
    this.safeWindowEventListeners = [];
  }

  // Add event listener which will be removed after DOM is removed
  addSafeEventListener(type, listener, options) {
    this.safeEventListeners.push({
      type: type,
      listener: listener,
      options: options,
    });

    this.addEventListener(type, listener, options);
  }

  // Add document event listener which will be removed after DOM is removed
  addSafeDocumentEventListener(type, listener, options) {
    this.safeDocumentEventListeners.push({
      type: type,
      listener: listener,
      options: options,
    });

    document.addEventListener(type, listener, options);
  }

  // Add window event listener which will be removed after DOM is removed
  addSafeWindowEventListener(type, listener, options) {
    this.safeWindowEventListeners.push({
      type: type,
      listener: listener,
      options: options,
    });

    window.addEventListener(type, listener, options);
  }

  onBroadcast(eventName, listener) {
    const wrapper = (e) => {
      listener.apply(null, [Object.assign({}, e.detail, { originalEvent: e })]);
    };

    this.addSafeWindowEventListener(eventName, wrapper);
  }

  onDocumentLoaded(listener) {
    this.addSafeWindowEventListener('DOMContentLoaded', listener);
  }

  isDebug() {
    return isDebuggerMode();
  }
}

function broadcast(eventName, data) {
  window.dispatchEvent(
    new CustomEvent(eventName, {
      detail: data,
    }),
  );
}

function onBroadcast(eventName, listener) {
  window.addEventListener(eventName, (e) => {
    listener.apply(null, [Object.assign({}, e.detail, { originalEvent: e })]);
  });
}

function isDebuggerMode() {
  return window.location.hash === '#debug';
}

function makeDebugger() {
  if (isDebuggerMode()) {
    const entry = ['🪳 %c[Debugger]', 'background:#ff9800;color:white'];
    return {
      log: console.log.bind(window.console, ...entry),
      debug: console.debug.bind(window.console, ...entry),
      info: console.info.bind(window.console, ...entry),
      active: true,
    };
  }

  return { log: () => {}, error: () => {}, info: () => {}, active: false };
}
window.Helpers.Debugger = makeDebugger();

window.Helpers.Customer.getLocation().then(function (geo) {
  const countryIso = geo.country.handle.toLowerCase();
  document.querySelectorAll('[data-show-country]').forEach(function (el) {
    if (el.getAttribute('data-show-country').toLowerCase().indexOf(countryIso) > -1) {
      el.classList.remove('hidden');
    } else {
      el.classList.add('hidden');
    }
  });
  document.querySelectorAll('[data-hide-country]').forEach(function (el) {
    if (el.getAttribute('data-hide-country').toLowerCase().indexOf(countryIso) > -1) {
      el.classList.add('hidden');
    } else {
      el.classList.remove('hidden');
    }
  });
});

window.addEventListener('klaviyoForms', function (e) {
  Shopify.analytics.publish('klaviyoForms', e.detail);
});

class KlaviyoClient {
  constructor(public_key) {
    this.key = public_key;
  }

  subscribe(email, phone, listId) {
    if (!listId) return console.warn('Klaviyo listId is required');
    const attributes = {};
    const subscriptions = {};
    if (!email && !phone) return console.warn('Klaviyo email or phone is required');
    if (email) {
      attributes.email = email;
      subscriptions.email = {
        marketing: {
          consent: 'SUBSCRIBED',
        },
      };
    }
    if (phone) {
      attributes.phone_number = phone;
      subscriptions.sms = {
        marketing: {
          consent: 'SUBSCRIBED',
        },
      };
    }

    attributes.subscriptions = subscriptions;

    return new Promise((resolve) => {
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + this.key, {
        method: 'POST',
        headers: {
          'content-type': 'application/vnd.api+json',
          accept: 'application/vnd.api+json',
          revision: '2025-01-15',
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: attributes,
                },
              },
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: listId,
                },
              },
            },
          },
        }),
      })
        .then((res) => {
          if (res.ok) {
            resolve({ status: res.status });
            return { status: res.status };
          }
          return res.json();
        })
        .then((data) => {
          resolve(data);
        });
    });
  }
  subscribeBis(email, phone, variantId) {
    if (!variantId) return console.warn('Klaviyo variantId is required');

    const attributes = {};
    const channels = [];
    if (!email && !phone) return console.warn('Klaviyo email or phone is required');
    if (email) {
      attributes.email = email;
      channels.push('EMAIL');
    }
    if (phone) {
      attributes.phone_number = phone;
      channels.push('SMS');
    }

    return new Promise((resolve) => {
      fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + this.key, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Revision: '2025-01-15',
        },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: attributes,
                },
              },
              channels: channels,
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: '$shopify:::$default:::' + variantId,
                },
              },
            },
          },
        }),
      })
        .then((res) => {
          if (res.ok) {
            resolve({ status: res.status });
            return { status: res.status };
          }
          return res.json();
        })
        .then((data) => {
          resolve(data);
        });
    });
  }
  updateProperties = window.Helpers.API.App.SyncToKlaviyo;
}
if (
  window.Helpers.Config.integrations &&
  window.Helpers.Config.integrations.klaviyo &&
  window.Helpers.Config.integrations.klaviyo.public_key
)
  window.Helpers.Klaviyo = new KlaviyoClient(window.Helpers.Config.integrations.klaviyo.public_key);

window.Helpers.Validate = {
  Email: function (email) {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      );
  },
  Phone: function (phone) {
    return String(phone).match(/^[0-9\s-]+$/);
  },
  IntlPhone: function (phone) {
    return String(phone).match(/^\d{6,15}$/);
  },
};

window.Helpers.formToJson = (form) => {
  const formData = new FormData(form);
  const result = {};

  for (const [key, value] of formData.entries()) {
    // Skip empty values
    if (!value) {
      continue;
    }

    // Handle array notation (fieldname[])
    if (key.endsWith('[]')) {
      const cleanKey = key.substring(0, key.length - 2);
      if (!result[cleanKey]) {
        result[cleanKey] = [];
      }
      result[cleanKey].push(value);
      continue;
    }

    // Handle nested object notation (object[property])
    const match = key.match(/^([^\[]+)\[([^\]]+)\]$/);
    if (match) {
      const [_, objectName, property] = match;
      if (!result[objectName]) {
        result[objectName] = {};
      }
      result[objectName][property] = value;
      continue;
    }

    // Handle regular fields
    result[key] = value;
  }

  return result;
};

document.addEventListener('click', function (e) {
  const link = e.target.tagName === 'A' ? e.target : e.target.closest('a');
  if (link)
    Shopify.analytics.publish('link_clicked', {
      href: link.href,
      id: link.id,
      name: link.name,
      tagName: link.tagName,
      type: link.type,
      value: link.value,
    });
});

window.Shopify.loadFeatures(
  [
    {
      name: 'consent-tracking-api',
      version: '0.1',
    },
  ],
  (error) => {
    if (error) {
      // Rescue error
    }

    if (window.Shopify.customerPrivacy.preferencesProcessingAllowed())
      window.dispatchEvent(new CustomEvent('analytics:preferencesProcessingAllowed'));
    if (window.Shopify.customerPrivacy.analyticsProcessingAllowed())
      window.dispatchEvent(new CustomEvent('analytics:analyticsProcessingAllowed'));
    if (window.Shopify.customerPrivacy.marketingAllowed())
      window.dispatchEvent(new CustomEvent('analytics:marketingAllowed'));
    if (window.Shopify.customerPrivacy.saleOfDataAllowed())
      window.dispatchEvent(new CustomEvent('analytics:saleOfDataAllowed'));
  },
);
document.addEventListener('visitorConsentCollected', (event) => {
  if (event.detail.preferencesAllowed) window.dispatchEvent(new CustomEvent('analytics:preferencesProcessingAllowed'));
  if (event.detail.analyticsAllowed) window.dispatchEvent(new CustomEvent('analytics:analyticsProcessingAllowed'));
  if (event.detail.marketingAllowed) window.dispatchEvent(new CustomEvent('analytics:marketingAllowed'));
  if (event.detail.saleOfDataAllowed) window.dispatchEvent(new CustomEvent('analytics:saleOfDataAllowed'));
});

class Toggler extends HTMLButtonElement {
  constructor() {
    super();
    this.commandFor = this.getAttribute('commandfor');
    this.commandName = this.getAttribute('command');
  }

  connectedCallback() {
    this.addEventListener('click', this.toggle.bind(this));
  }

  toggle() {
    if (this.commandFor) {
      console.log('toggle', this.commandFor, this.commandName);
      this.executeCommand(document.querySelector('#' + this.commandFor), this.commandName);
    }
  }

  executeCommand(el, commandName) {
    console.log('executeCommand', el, commandName);
    if (commandName == 'open') {
      el.open = true;
    }
    if (commandName == 'close') {
      el.open = false;
    }
    if (commandName == 'toggle') {
      el.open = !el.open;
    }
  }
}

customElements.define('command-toggler', Toggler, { extends: 'button' });

document.addEventListener('click', function (e) {
  if (e.target.hasAttribute('data-click-event') || e.target.closest('[data-click-event]')) {
    const clickTarget = e.target.hasAttribute('data-click-event') ? e.target : e.target.closest('[data-click-event]');
    const clickEvent = clickTarget.getAttribute('data-click-event');
    const text =
      e.target.textContent && e.target.textContent.length > 1 ? e.target.textContent : clickTarget.textContent;
    if (clickEvent) {
      Shopify.analytics.publish('custom_click', {
        event: clickEvent,
        label: text,
      });
    }
  }
});

class CopyButton extends HTMLButtonElement {
  constructor() {
    super();
    this.text = this.getAttribute('data-text');
  }

  connectedCallback() {
    this.addEventListener('click', this.copy.bind(this));
  }

  copy() {
    window.Helpers.Clipboard.Copy(this.text);
    this.classList.add('success');
    setTimeout(() => {
      this.classList.remove('success');
    }, 3000);
  }
}

customElements.define('copy-button', CopyButton, { extends: 'button' });
